import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root");
const is404 = !!container.getAttribute("data-is404");
const content = document.getElementById("wp-content");
const rawSecondaryMenuItems = container.getAttribute(
  "data-rawsecondarymenuitems"
);

const rawPrimaryMenuItems = container.getAttribute("data-rawprimarymenuitems");
const rawSitemapMenuItems = container.getAttribute("data-rawsitemapnavitems");
const rawFooterMenuItems = container.getAttribute("data-rawfooternavitems");
const isi = container.getAttribute("data-isi");
const tags = container.getAttribute("data-tags");
const rawFaqs = container.getAttribute("data-rawfaqs");
const rawTestimonials = container.getAttribute("data-rawtestimonials");
const rawVideoPageInfo = container.getAttribute("data-rawvideopageinfo");
const rawHCPResources = container.getAttribute("data-rawhcpresources");
const references = container.getAttribute("data-references");
const pageTitle = container.getAttribute("data-pagetitle");
const headerImageDesktop = container.getAttribute("data-headerimagedesktop");
const headerImageTablet = container.getAttribute("data-headerimagetablet");
const headerImageMobile = container.getAttribute("data-headerimagemobile");
const hcpCTA = container.getAttribute("data-hcpCTA");
const patientCTA = container.getAttribute("data-patientCTA");

const root = createRoot(container);
root.render(
  <App
    is404={is404}
    rawContent={content?.innerHTML}
    rawSecondaryMenuItems={rawSecondaryMenuItems}
    rawPrimaryMenuItems={rawPrimaryMenuItems}
    rawSitemapMenuItems={rawSitemapMenuItems}
    rawFooterMenuItems={rawFooterMenuItems}
    isi={isi}
    rawFaqs={rawFaqs}
    tags={tags}
    rawTestimonials={rawTestimonials}
    rawVideoPageInfo={rawVideoPageInfo}
    rawHCPResources={rawHCPResources}
    references={references}
    pageTitle={pageTitle}
    headerImageDesktop={headerImageDesktop}
    headerImageTablet={headerImageTablet}
    headerImageMobile={headerImageMobile}
    hcpCTA={hcpCTA}
    patientCTA={patientCTA}
  />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
